import React from "react";
import IconBlock from "../components/IconBlock";

import DownloadResume from "../utils/DownloadResume";

import { LightbulbIcon, PaletteIcon, GearIcon } from "../icons/AboutIcons";

const About = React.forwardRef((props, ref) => {
	return (
		<div ref={ref} className="small-container">
			<div className="small-box">
				<div className="heading">About Me</div>
				<div className="body about-container">
					<div className="description-area">
						<div className="description-text">
							I am a Software Developer who builds software solutions that
							address everyday problems. I enjoy exploring new technologies,
							building software systems, and collaborating with others. With
							experience in full-stack development, I am always looking to apply
							and grow my skills in meaningful projects. Please feel free to
							reach out!
						</div>
						<div className="description-resume">
							<button className="download-btn" onClick={() => DownloadResume()}>
								<span>Download Resume</span>
								<i className="material-icons">download</i>
							</button>
						</div>
					</div>
					<div className="icons-container">
						<IconBlock
							icon={<LightbulbIcon />}
							label={"Innovative"}
							link={""}
						/>
						<IconBlock icon={<PaletteIcon />} label={"Creative"} link={""} />
						<IconBlock icon={<GearIcon />} label={"Productive"} link={""} />
					</div>
				</div>
			</div>
		</div>
	);
});

export default About;
